import { Content } from "./edit";
import metadata from "./block.json";

/**
 * Pre-dynamic static save (5 baked star SVGs). Reuses the same `Content`
 * component the block used before the server-render conversion, so existing
 * ratings validate against this deprecation and migrate to the empty save when
 * re-edited. Frontend rendering already comes from render_callback regardless.
 */
const v1 = {
  attributes: metadata.attributes,
  supports: metadata.supports,
  save(props) {
    return <Content {...props} isSave={true} />;
  },
};

export default [v1];
